/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button } from "@nordcloud/gnui";
import { Sidebar } from "~/components";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { useDisclosure } from "~/hooks";
import { ROUTES } from "~/routing/routes";
import { MappingRulesTable } from "./components/MappingRulesTable";
import { AddMappingRuleForm } from "./hooks/useCreateMappingRule/AddMappingRuleForm";

const breadcrumbsLabels = [
  { label: "Dashboard", uri: "/" },
  { label: "Mapping Rules", uri: ROUTES.mappingRules.index },
];

export function MappingRulesPage() {
  const { isOpen, open, close } = useDisclosure();

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Mapping Rules"
            customBreadcrumbs={breadcrumbsLabels}
          >
            <Button icon="plus" onClick={open}>
              Add Mapping Rule
            </Button>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <MappingRulesTable />
            <Sidebar title="Add Mapping Rule" isOpen={isOpen} onClick={close}>
              <AddMappingRuleForm onClose={close} />
            </Sidebar>
          </Box>
        </Col>
      </Row>
    </>
  );
}
